import { useContext, useEffect, useRef } from 'react';
import { MeContext } from '../../../context/MeContext';
import { useTrackEventMutation } from '../../../store/redux/api/onboardingApi';

const STORAGE_KEY = 'email_cta_stage';

export const captureEmailCtaStage = (): void => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') !== 'mandrill') return;
    const stage = params.get('utm_content');
    if (stage) sessionStorage.setItem(STORAGE_KEY, stage);
  } catch {
    // sessionStorage can throw in private mode; tracking is best-effort.
  }
};

export const useTrackEmailCtaClick = (): void => {
  const meCtx = useContext(MeContext) as {
    state: { account: { id?: string | number } | null };
  };
  const accountId =
    meCtx?.state?.account?.id != null
      ? String(meCtx.state.account.id)
      : undefined;
  const [trackEvent] = useTrackEventMutation();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!accountId || firedRef.current) return;

    let stage: string | null = null;
    try {
      stage = sessionStorage.getItem(STORAGE_KEY);
    } catch {
      return;
    }
    if (!stage) return;

    firedRef.current = true;
    trackEvent({ event: 'onboarding-email-cta-clicked', stage })
      .unwrap()
      .then(() => {
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch {
          // Soft-fail: the API only tracks while the value is present, so a stuck key at worst re-reports a deduplicated LD conversion.
        }
      })
      .catch(() => {
        firedRef.current = false;
      });
  }, [accountId, trackEvent]);
};
